import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PortalNotifications() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!user) return;
    api.get("/notifications").then((r) => setItems(r.data || [])).catch(() => {});
  }, [user]);
  const mark = async (n) => {
    if (n.read) return;
    await api.post(`/notifications/${n.id}/read`);
    setItems((cur) => cur.map((x) => (x.id === n.id ? { ...x, read: true } : x)));
  };

  return (
    <div className="p-6 lg:p-12 max-w-3xl" data-testid="portal-notifications">
      <div className="eyebrow mb-1">Studio</div>
      <h1 className="font-heading font-light text-3xl lg:text-4xl tracking-tighter mb-8">Notifications</h1>
      {items.length === 0 ? (
        <div className="border border-line bg-white p-14 text-center text-stone">Nothing to show.</div>
      ) : (
        <div className="border border-line bg-white divide-y divide-line">
          {items.map((n) => (
            <div key={n.id} onClick={() => mark(n)} className={`p-4 flex items-start gap-3 hover:bg-sand/40 cursor-pointer ${n.read ? "opacity-70" : ""}`}>
              <Bell size={16} className="text-stone mt-0.5" />
              <div className="flex-1">
                <div className="text-sm">{n.message}</div>
                <div className="text-xs font-mono text-stone mt-1">{n.created_at?.slice(0, 16).replace("T", " ")}</div>
              </div>
              {n.type === "new_enquiry" && (
                <Link to="/portal/enquiries" className="text-xs uppercase tracking-widest border-b border-ink pb-0.5">View →</Link>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
